// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_P2q","buttons":"styles_buttons__3D3tD"};